import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { createAction } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "categoryManagement",
  initialState: {
    isCategoryData: [],
    isSingleCategoryObj: {},
    isCategoryModalOpen: false,
    isAdding: false,
    onSuccessMessage: {},
    isDeleteCategory: false,
  },

  reducers: {
    // GET Request
    categoryObjectNull: (categoryManagement, action) => {
      categoryManagement.isSingleCategoryObj = {};
    },
    allCategoryReceived: (categoryManagement, action) => {
      categoryManagement.isCategoryData = action.payload;
    },
    createCategoryModalOpened: (categoryManagement, action) => {
      categoryManagement.isCategoryModalOpen = true;
    },
    createCategoryModalClosed: (categoryManagement, action) => {
      categoryManagement.isCategoryModalOpen = false;
    },
    categoryAdding: (categoryManagement, action) => {
      categoryManagement.isAdding = true;
    },
    categoryAdded: (categoryManagement, action) => {
      categoryManagement.isAdding = false;
      categoryManagement.onSuccessMessage = action.payload;
    },
    updateSingleCategoryObject: (categoryManagement, action) => {
      categoryManagement.isSingleCategoryObj = action.payload;
    },
    categoryDeletedSuccess: (categoryManagement, action) => {
      categoryManagement.isDeleteCategory = true;
    },
    categoryStartSuccess: (categoryManagement, action) => {
      categoryManagement.isDeleteCategory = true;
    },
  },
});

export const {
  allCategoryReceived,
  updateSingleCategoryObject,
  createCategoryModalOpened,
  createCategoryModalClosed,
  categoryAdding,
  categoryAdded,
  categoryObjectNull,
  categoryDeletedSuccess,
  categoryStartSuccess,
} = slice.actions;

export default slice.reducer;

// action creator

export const getAllCategoryList = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder-category",
    method: "get",
    onSuccess: allCategoryReceived.type,
  });

export const addNewCategory = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/reminder-category",
    method: "post",
    data: data,
    onStart: categoryAdding.type,
    onSuccess: categoryAdded.type,
  });

export const getDeleteCategory = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder-category",
    method: "delete",
    data: data,
    onStart: categoryStartSuccess.type,
    onSuccess: categoryDeletedSuccess.type,
  });
// Selector
export const getCategoryListData = createSelector(
  (state) => state.entities.categoryManagement,
  (categoryManagement) => categoryManagement.isCategoryData.reminderCategories
);

export const getCategoryModalOpen = createSelector(
  (state) => state.entities.categoryManagement,
  (categoryManagement) => categoryManagement.isCategoryModalOpen
);
/////
export const getCreateLoading = createSelector(
  (state) => state.entities.categoryManagement,
  (categoryManagement) => categoryManagement.isAdding
);
export const getSelectedCategoryObject = createSelector(
  (state) => state.entities.categoryManagement,
  (categoryManagement) => categoryManagement.isSingleCategoryObj
);
export const getCategorySuccess = createSelector(
  (state) => state.entities.categoryManagement,
  (categoryManagement) => categoryManagement.onSuccessMessage
);
export const getCreateFlag = createSelector(
  (state) => state.entities.categoryManagement,
  (categoryManagement) => categoryManagement.isAdding
);
export const deleteApiStartFlag = createSelector(
  (state) => state.entities.categoryManagement,
  (categoryManagement) => categoryManagement.isDeleteCategory
);
